module.exports = __webpack_public_path__ + "static/media/shopsblue.22cb2749.svg";